import { put, takeEvery, call } from "redux-saga/effects";
import * as actionTypes from "./constants";
// import { appConfig } from "../../config";
import "react-toastify/dist/ReactToastify.css";
// import EndPoints from "../endpoints";
import fmApi from "../APIWrapper";

function* fetchMyProfile() {
  // const fmsuser = JSON.parse(localStorage.getItem("FmsUser"));
  // const token = localStorage.getItem("fmsToken");
  try {
    // const res = yield fetch(
    //   `${appConfig.urlPrefixIp}/profile/society/id/67`,

    //   {
    //     method: "GET",
    //     headers: {
    //       Accept: "application/json",
    //       "auth-token": EndPoints.token,
    //       username: fmsuser.username,
    //       Authorization: `Bearer ${token}`,
    //       type:'Web'
    //     },
    //   }
    // );

    // if (!res.ok) {
    //   throw res;
    // } else {
    //   const resJSON = yield res.json();
    const resJSON = yield call(fmApi.FetchprofileByIDApi);

    yield put({
      type: actionTypes.FETCH_MYPROFILES_SUCCESS_ACTION,
      payload: resJSON,
    });
    // }
  } catch (err) {
    if (err.status === 401) {
    }
    yield put({
      type: actionTypes.FETCH_MYPROFILES_FAIL_ACTION,
      payload: err,
    });
  }
}

export function* myProfileActionWatcher() {
  yield takeEvery(actionTypes.FETCH_MYPROFILES_INIT_ACTION, fetchMyProfile);
}
